"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { ChartLine, Cpu, Target, ChevronRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
const competencies = [{
  title: "Personal Credit Builder",
  description: "Transform your personal financial profile with strategic management designed to maximize your borrowing power and score.",
  icon: ChartLine,
  href: "/CreditSolutionsPage"
}, {
  title: "Business Credit Scaling",
  description: "Establish a robust corporate credit identity that operates independently of your personal assets to secure high-limit funding.",
  icon: Cpu,
  href: "/CreditSolutionsPage"
}, {
  title: "Strategic Consulting",
  description: "Expert guidance on capital allocation and business management to help you scale operations and achieve sustainable growth.",
  icon: Target,
  href: "/CreditSolutionsPage"
}];
export default function OurCoreCompetencies() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222632" id="unlock-your-funding-potential" className="bg-background text-foreground py-24 md:py-32 relative overflow-hidden" ref={sectionRef}>
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--color-primary)_0%,_transparent_70%)] opacity-10 pointer-events-none" />

      <div className="container mx-auto px-6 relative z-10">
        <div className={`max-w-3xl mb-16 md:mb-24 transition-all duration-1000 ease-out ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-5xl font-bold tracking-tighter text-foreground mb-6">
            High-Performance <br className="hidden md:block" />
            <span className="text-primary">Financial Luxury</span>
          </h2>
          <p className="text-lg text-muted-foreground font-default max-w-2xl leading-relaxed">
            Lake Stone Enterprise provides the solid foundation and fluid capital required for modern expansion. Get the funding you deserve with our elite credit management systems.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {competencies.map((item, i) => {
          const Icon = item.icon;
          return <div key={item.title} data-index={i} className={`transition-all duration-700 ease-out delay-${i * 200} ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                <Card className="group h-full flex flex-col bg-card/60 backdrop-blur-xl border-border/50 hover:border-primary/60 hover:bg-card/80 transition-all duration-500 overflow-hidden relative rounded-lg shadow-md hover:shadow-3xl">
                  {}
                  <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-primary to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  
                  <CardHeader className="pb-4 pt-8">
                    <div className="mb-6 p-3 bg-secondary/30 rounded-md w-fit text-primary group-hover:scale-110 group-hover:shadow-[0_0_20px_rgba(16,185,129,0.3)] transition-all duration-500 ease-out">
                      <Icon size={28} strokeWidth={1} />
                    </div>
                    <CardTitle className="font-default text-xl font-bold tracking-tight text-foreground group-hover:text-primary transition-colors duration-300">
                      {item.title}
                    </CardTitle>
                  </CardHeader>
                  
                  <CardContent className="flex-grow pb-8">
                    <CardDescription className="font-default text-base text-muted-foreground leading-relaxed">
                      {item.description}
                    </CardDescription>
                  </CardContent>
                  
                  <CardFooter className="pt-0 pb-8 mt-auto">
                    <Link to={item.href} className="inline-flex items-center text-sm font-semibold uppercase tracking-wider text-primary opacity-0 -translate-x-4 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 focus-visible:opacity-100 focus-visible:translate-x-0 outline-none rounded-md focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background">
                      View Strategy
                      <ChevronRight className="ml-1 size-4 transition-transform duration-300 group-hover:translate-x-1" />
                    </Link>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}